import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import {
  Step1FormData,
  EXPEDITE_FEE,
  REVIEW_NOTE,
} from '../create-request-wizard.types';
import {
  ParsedFileData,
  FileTotals,
} from '../../../../core/models/file-upload.model';

@Component({
  selector: 'app-step-summary',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './step-summary.component.html',
  styleUrls: ['./step-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepSummaryComponent {
  /** Contact information from Step 1 */
  @Input() contactData: Step1FormData | null = null;

  /** Parsed files from Step 2 */
  @Input() parsedFiles: ParsedFileData[] = [];

  /** File totals from Step 2 */
  @Input() fileTotals: FileTotals | null = null;

  /** Expedite selection from Step 3 */
  @Input() isExpedited = true;

  /** Expedite fee constant */
  readonly expediteFee = EXPEDITE_FEE;

  /** Review note text */
  readonly reviewNote = REVIEW_NOTE;

  /**
   * Check if step can proceed (always true for Summary).
   * Summary is read-only with no validation required.
   */
  canProceed(): boolean {
    return true;
  }
}
